import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/ui/components/tooltip";
import { LockOpen1Icon } from "@radix-ui/react-icons";

export const VAULT_FALLBACK_LABEL_KEY = "piiVault.fallbackMark";

type VaultFallbackMarkProps = {
  /** Undefined when the vault was not read for this document. */
  isFromVault: boolean | undefined;
};

export default function VaultFallbackMark({
  isFromVault,
}: VaultFallbackMarkProps) {
  const t = useTranslation();
  const isSuperAdmin = useViewerIsSuperAdmin();

  if (!isSuperAdmin || isFromVault !== false) return null;

  const label = t(VAULT_FALLBACK_LABEL_KEY);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span aria-label={label}>
          <LockOpen1Icon className="size-3 text-amber-500" />
        </span>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
